import Vue from 'vue'
import Mutations from '../data/mutations'
export default {
  namespaced: true,
  state: {
    tips: [],
    listView: false,
    sortBy: '',
    filterBy: '',
    loadingTips: false,
    selectedRecordType: 'Active'
  },
  mutations: Mutations,
  actions: {
    resetForm(context) {
      context.commit('modifyContractor', '')
      context.commit('modifyTip', '')
      context.commit('modifyVehicle', '')
      context.commit('modifySite', '')
      context.commit('resetTrips')
    }
  },
  getters: {
    getTips: state => state.tips
  }
}
